angular.module 'zc.master.zcliteProjects'

.controller 'MasterZcliteProjectsListCtrl', (
    $filter,
    $q,
    $scope,
    $translate,
    Devise,
    Page,
    MasterProject,
    ProjectStats,
    SearchFilter,
    ZcsKpi) ->

  Page.setBodyClass ''
  $translate('masterZclite.projects.list.siteList').then (translation) ->
    Page.setTitle translation

  # Number of days when implementation status pending color become red
  PENDING_DATE = 5

  $scope.projects = []
  $scope.filteredProjects = []

  $scope.install_status =
    all: $translate.instant('masterZclite.projects.list.siteList')
    companyinfo_confirmed_at: $translate.instant('masterZclite.projects.list.companyinfoConfirmedAt')
    siteinfo_confirmed_at: $translate.instant('masterZclite.projects.list.siteinfoConfirmedAt')
    tracking_tag_confirmed_at: $translate.instant('masterZclite.projects.list.trackingTagConfirmedAt')
    conversion_tag_confirmed_at: $translate.instant('masterZclite.projects.list.conversionTagConfirmedAt')
    complete: $translate.instant('masterZclite.projects.list.complete')

  $scope.selling_methods =
    all: $translate.instant('masterZclite.projects.list.all')
    direct_sales: $translate.instant('masterZclite.projects.list.directSales')
    make_repeater: 'MR'
    agencies: $translate.instant('masterZclite.projects.list.agencies')

  $scope.filters = SearchFilter.resolveFromLocation()
  SearchFilter.setComponentDefaults('masterProjectsList', {
    show_demo:
      default: false
    show_test:
      default: false
    show_terminated:
      default: false
    visible_group:
      default: 'settings'
    sort_prop:
      default: 'apikey'
    sort_direction:
      default: 'desc'
    install_status:
      default: 'all'
    selling_method:
      default: 'all'
  })

  $scope.$on '$destroy', () ->
    SearchFilter.removeComponentDefaults 'masterProjectsList'

  $scope.setVisibleGroup = (visibleGroup) ->
    $scope.filters.visible_group = visibleGroup
    SearchFilter.updateComponentDefaults 'masterProjectsList'

  $scope.setSortProp = (key) ->
    if $scope.filters.sort_prop == key
      if $scope.filters.sort_direction == 'desc'
        $scope.filters.sort_direction = 'asc'
      else
        $scope.filters.sort_direction = 'desc'
    else
      $scope.filters.sort_prop = key
      $scope.filters.sort_direction = 'desc'
    $scope.filterProjects()

  $scope.filterProjects = () ->
    sortDirectionReverse = ($scope.filters.sort_direction == 'desc')

    $scope.filteredProjects = $scope.projects
    if !$scope.filters.show_terminated
      $scope.filteredProjects = _.filter($scope.filteredProjects, (p) -> !p.terminated_at)
    if !$scope.filters.show_demo
      $scope.filteredProjects = _.filter($scope.filteredProjects, (p) -> p.is_demo == false)
    if !$scope.filters.show_test
      $scope.filteredProjects = _.filter($scope.filteredProjects, (p) -> p.is_test == false)

    $scope.filteredProjects = $filter("projectText")($scope.filteredProjects, $scope.filters.search_term)
    $scope.filteredProjects = filterByInstallStatus $scope.filteredProjects, $scope.filters.install_status
    $scope.filteredProjects = filterBySellingMethod $scope.filteredProjects, $scope.filters.selling_method
    $scope.filteredProjects = $filter('orderBy')($scope.filteredProjects, $scope.filters.sort_prop, sortDirectionReverse)
    $scope.filteredProjects = $filter('emptyToEnd')($scope.filteredProjects, $scope.filters.sort_prop, sortDirectionReverse)

    SearchFilter.set $scope.filters
    SearchFilter.updateComponentDefaults 'masterProjectsList'

  #custom filters
  filterByInstallStatus = (projects, install_status) ->
    _.filter projects, (project) ->
      return true if install_status == 'all'
      project.install_status == install_status

  filterBySellingMethod = (projects, selling_method) ->
    _.filter projects, (project) ->
      return true if selling_method == 'all'

      if selling_method == 'direct_sales'
        return project.agency_id == 5

      if selling_method == 'make_repeater'
        return project.agency_id == 9

      if selling_method == 'agencies'
        return project.agency_id != 5 && project.agency_id != 9

  #generate project data
  $scope.updateData = () ->
    SearchFilter.set $scope.filters
    apikeys = _.map $scope.projects, (p) -> p.apikey
    # request too long so split in chunks
    apikeyChunks = _.chunk(apikeys, 50)
    promises = _.map(apikeyChunks, (apikeyChunk) ->
      # NOTE: the results come as { apikey1: stats, apikey2: stats } type objects,
      # not an plain array
      ProjectStats.getDailyProjectStats({
        apikey: {
          $in: apikeyChunk
        },
        start_at: {
          $gte: moment($scope.filters.start_at).toDate()
          $lt: moment($scope.filters.end_at).add(1, 'day').toDate()
        }
      })
    )

    $q.all(promises)
    .then (results) ->
      # combine multiple objects into one
      statsByApikey = _.reduce(results, (chunk, obj) =>
        return _.merge(obj, chunk)
      , {})

      for project in $scope.projects
        project.stats = statsByApikey[project.apikey]

      $scope.filterProjects()

  setInstallationStatus = (project) ->
    if !project.companyinfo_confirmed_at
      project.install_status = "companyinfo_confirmed_at"
      project.install_status_pending_time = calculatePendingDate(project.created_at)
    else if !project.siteinfo_confirmed_at
      project.install_status = "siteinfo_confirmed_at"
      project.install_status_pending_time = calculatePendingDate(project.companyinfo_confirmed_at)
    else if !project.tracking_tag_confirmed_at
      project.install_status = "tracking_tag_confirmed_at"
      project.install_status_pending_time = calculatePendingDate(project.siteinfo_confirmed_at)
    else if !project.conversion_tag_confirmed_at
      project.install_status = "conversion_tag_confirmed_at"
      project.install_status_pending_time = calculatePendingDate(project.tracking_tag_confirmed_at)
    else
      project.install_status = "complete"

  setOperationStatus = (project) ->
    return unless project.conversion_tag_confirmed_at
    first_campaign_start_at = ZcsKpi.firstCampaignStartAt(project.started_campaigns)
    last_campaign_end_at = ZcsKpi.lastCampaignEndAt(project.started_campaigns)
    if not first_campaign_start_at
      project.operation_status = 'before_first_campaign_start'
      project.operation_status_pending_time = calculatePendingDate(project.conversion_tag_confirmed_at)
    else if last_campaign_end_at.isBefore(moment())
      project.operation_status = 'after_last_campaign_end'
      project.operation_status_pending_time = calculatePendingDate(last_campaign_end_at)
    else
      project.operation_status = 'current_campaign_in_delivery'

  calculatePendingDate = (date) ->
    from = moment()
    to = moment(date)
    from.diff(to, 'days')

  $scope.checkPendingDate = (pending_date) ->
    if pending_date > PENDING_DATE
      return true

  $scope.checkIsAssignee = (project) ->
    Devise.currentUser.email in (user.email for user in project.users)

  $scope.assignCurrentUser = (project) ->
    MasterProject.assign
      projectId: project.id
    ,
      userId: Devise.currentUser.id
    .then ->
      project.users.push Devise.currentUser
      project.isAssignee = $scope.checkIsAssignee(project)

  $scope.unassignCurrentUser = (project) ->
    MasterProject.unassign
      projectId: project.id
    ,
      userId: Devise.currentUser.id
    .then ->
      _.remove project.users, (user) ->
        user.email is Devise.currentUser.email
      project.isAssignee = $scope.checkIsAssignee(project)

  MasterProject.all()
  .then (allProjects) ->
    $scope.projects = _.filter(allProjects, (p) -> p.product_line == 'zenclerk_s')
    for project in $scope.projects
      setOperationStatus(project)
      setInstallationStatus(project)
    $scope.filterProjects()

    $scope.updateData()



// WEBPACK FOOTER //
// ./src/master_admin_modules/master.zclite_projects/list.coffee